import React from 'react';

function ErrorPage() {
  return <div className='mt-5 p-5 m-5 text-center bg-dark text-white'>404 | Page Not Found</div>;
}

export default ErrorPage;
